<div class="container" >
<div id="combo-empresa" class="d-t-none combo-empresa sp-header__topbar">
    <dx-select-box id='empresa' #empresa [dataSource]="empresaLista" placeholder='Seleccione empresa'
        [showClearButton]="false" valueExpr="code" [value]="codEmpresa" displayExpr="name" fieldTemplate="empresaSelect"
        (onValueChanged)="selectEmpresa($event)" (onClosed)="onClosedEmpresa($event)" [(selectedItem)]="selectedItem"
        [searchEnabled]="false" showScrollbar="always" [wrapItemText]="true" class="m-0 w-100 h-100 combo-empresa">

        <div *dxTemplate="let empresa of 'empresaSelect'">
            <div id="divEm" Class="d-flex justify-content-center">
                <img *ngIf="selectedItem" style="    width: 90px;height: 50px;" class="symbol-label"
                    src="data:image/jpeg;base64,{{selectedItem.photo }}">
                <img *ngIf="!selectedItem" src="./assets/img/companyfault.png" class="logo-company img-fluid" alt="" />
                <!-- <img style="height: 66px;" alt="Logo"   [src]="empresa && empresa.bmp_repo | safeUrl"  />            -->
            </div>
            <div Class="d-none">
                <dx-text-box [readOnly]="true">
                </dx-text-box>
            </div>
        </div>
        <div class="m-0" *dxTemplate="let empresa of 'item'">
          <div class="empresa-item d-flex align-items-center justify-content-between w-100">
            <!-- Logo -->
            <img class="empresa-logo" alt="Logo" src="data:image/jpeg;base64,{{empresa.photo}}">
        
            <!-- Texto -->
            <span class="empresa-name text-truncate">
              {{ empresa.name }}
            </span>
          </div>
        </div>
        
        
        

    </dx-select-box>
</div>

<div class="sidebar-major">
  <button class="sp-aside-close" id="sp_aside_close_btn" aria-label="Cerrar">
    <i class="la la-close"></i>
  </button>

  <aside
    class="sp-aside sidebar sp-aside--fixed sp-grid__item sp-grid sp-grid--desspop sp-grid--hor-desspop aside responsive_sidebar expanding"
    #sp_aside
    id="sp_aside"
    [ngClass]="{ 'collapsed': isSidebarCollapsed }">

    <!-- Botón para cerrar/abrir menú -->
    <div class="sp-aside__brand-tools">
      <!-- Botón para MÓVIL (abre/cierra menú) -->
      <button *ngIf="isMobile"
              class="d-lg-flex sidebar-text sp-aside__brand-aside-toggler--left"
              (click)="toggleDrawer()">
        <i [class]="isDrawerOpen ? 'fa-solid fa-times fs-6 side-arrow' : 'fa-solid fa-bars fs-6 side-arrow'"></i>
      </button>
    
      <!-- Botón para DESKTOP (colapsa/expande menú) -->
      <button *ngIf="!isMobile"
              class="d-lg-flex sidebar-text sp-aside__brand-aside-toggler--left"
              id="sp_aside_toggler"
              (click)="toggleCollapse()"
              title="Cambiar menú">
        <i [class]="isSidebarCollapsed ? 'fa-solid fa-angles-right fs-6 side-arrow' : 'fa-solid fa-angles-left fs-6 side-arrow'"></i>
      </button>
    </div>
    <!-- Header para nombre y cargo -->
<!-- Header para nombre y cargo -->
<div *ngIf="user$ | async as _user" class="sp-aside__brand-name">
  <!-- FOTO: siempre visible -->
  <div class="flex-fill avatars__side rounded-circle m-sm-0 text-center user-photo">
    <img *ngIf="photouser != null"
         src="data:image/jpeg;base64,{{photouser}}"
         class="rounded-circle border-white user-icon" alt="Usuario">
    <img *ngIf="photouser == null"
         src="./assets/img/avatars/no-user.png"
         class="rounded-circle border-white user-icon" alt="Usuario">
  </div>

  <!-- NOMBRE/CARGO: ocultable -->
  <div class="flex-fill d-flex flex-column align-items-center user-info">
    <div class="fw-extrabold col text">{{ _user.firstname }}</div>
    <div class="text-white col text">{{ userInfo.nom_carg }}</div>
  </div>
</div>


    <!-- Search -->
    <form class="sp-subheader__search hide-Search mt-2 flex" id="sp_subheader_search_form" sp-hidden-height="75">
      <div class="input-group">
        <div class="input-group-append">
          <i class="flaticon2-search-1"></i>
        </div>
        <input type="search" class="form-control" placeholder="Buscar programa" name="generalSearch"
          autocomplete="new-generalSearch" [(ngModel)]="userSearch" (keydown.enter)="onEnterPress($event)">
      </div>
    </form>

    <!-- Menu -->
    <div class="sp-aside-menu-wrapper sp-grid__item sp-grid__item--fluid scroll" id="sp_aside_menu_wrapper">
      <div id="sp_aside_menu" class="sp-aside-menu sp-scroll aside-menu ps">
        <div class="content-menu sidebar overflow-auto">
          <ul class="sp-menu__nav" *ngIf="ShowMenu">

            <ng-container *ngIf="isSearching; else elseTemplate">
              <dx-tree-view class="sp-menu__item sp-menu__item--submenu has-submenu"
                [scrollDirection]="'both'" [rootValue]="0" dataStructure="plain"
                [createChildren]="createChildren" (onItemClick)="clickMain($event)"
                [noDataText]="'Sin datos'" [searchEnabled]="false"
                itemTemplate="itemTemplate">
                <div *dxTemplate="let item of 'itemTemplate'" #container>
              <button class="sp-menu__link sp-menu__toggle d-flex align-items-center w-100">
  <i [class]="item.icono || 'fa-solid fa-bars-staggered'" class="aside__icon me-2"></i>

<span 
  *ngIf="!isSidebarCollapsed"
  class="sp-menu__link-text fw-bold flex-grow-1 tooltip-css"
  [attr.data-tooltip]="item.text">
  {{ item.text | titlecase }}
</span>
</button>

                  <dx-context-menu *ngIf="!item.hasItems"
                    [dataSource]="[{ text: 'Agregar a favoritos', icon: 'favorites', action: 'add', id: item.microApplicationId }]"
                    [target]="container" [width]="200" (onItemClick)="itemClick($event)">
                  </dx-context-menu>
                </div>
              </dx-tree-view>
            </ng-container>

            <ng-template #elseTemplate>
              <li *ngFor="let item of mainDataSearch" class="sp-menu__item sp-menu__item--submenu has-submenu">
                <button class="sp-menu__link sp-menu__toggle d-flex align-items-center w-100"
                  (click)="clickMainsearch(item)" #containerFilter>
                  <i [class]="item.icon || 'fa-solid fa-bars-staggered'" class="aside__icon me-2"></i>
                  <span *ngIf="!isSidebarCollapsed" class="sp-menu__link-text fw-bold">{{ item.text | titlecase }}</span>
                </button>

                <dx-context-menu
                  [dataSource]="[{ text: 'Agregar a favoritos', icon: 'favorites', action: 'add', id: item.microApplicationId }]"
                  [target]="containerFilter" [width]="200" (onItemClick)="itemClick($event)">
                </dx-context-menu>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="sp-aside__footer sp-grid__item" id="sp_aside_footer" sp-hidden-height="59">
      <div class="sp-aside__footer-nav">
        <div class="sp-aside__footer-item bottom-0 menu w-100">
          <div class="hide-vers w-95 pt-0">
            <img class="mx-auto w-50 d-block" src="assets/img/loading-company.png" alt="">
            <p class="text-white d-inline">© Digital Ware 1992 - {{year}} &emsp;</p>
          </div>
        </div>
      </div>
    </div>

  </aside>
</div>

</div>